var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"send-receive-component"},[_c('div',{staticClass:"result"},[_vm._v(" "+_vm._s(_vm.computedTime)+" "+_vm._s(_vm.messageState)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }